import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Body2, Caption1 } from "@activecollab/components";
import moment from "moment";
import PropTypes from "prop-types";
import { RRule } from "rrule";
import { getPersonalizedDateFormat } from "~/store/selectors/selector.configOptions";
import { formatDateSmart } from "~/utils/date";
import { getCalendarServiceName, isAllDay } from "../Calendar/calendarUtils";

export const ExternalCalendarEventDetails = ({ calendar, event }) => {
  const { t } = useTranslation();
  const format = useSelector(getPersonalizedDateFormat);

  const repeats = useMemo(() => {
    if (event.rrule !== null) {
      const dtStart = isAllDay(event)
        ? `TZID=UTC:${moment.unix(event.starts_on).utc().format().replaceAll("-", "").replaceAll(":", "")}`
        : `TZID=UTC:${moment
            .unix(event.starts_on)
            .utc()
            .format("YYYY-MM-DD")
            .replaceAll("-", "")}T${event.starts_on_time.replaceAll(":", "")}`;

      const rule = RRule.fromString(
        `DTSTART;${dtStart};\n
    RRULE:${event.rrule}`
      );

      return rule.toText();
    }
    return null;
  }, [event]);

  return (
    <div className="tw-flex tw-flex-col tw-gap-1">
      <Body2
        weight="medium"
        color="primary"
      >
        {t("Imported from {{service}}", { service: getCalendarServiceName(calendar) })}
      </Body2>
      <Caption1
        color="secondary"
        className="tw-capitalize"
      >
        {repeats}
      </Caption1>
      <Caption1 color="secondary">
        {t("Last update")}
        {": "}
        {formatDateSmart(calendar.last_refresh, format)}
      </Caption1>
    </div>
  );
};
ExternalCalendarEventDetails.propTypes = {
  calendar: PropTypes.object,
  event: PropTypes.object,
};
